import React from "react";

const RefreshCircleIcon20pxSvgV2 = ({
  size = 16,
  strokeWidth = 2.2,
  className,
  color = "#0057FF",
  ...props
}) => (
  <svg width={size} height={size} viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ stroke: color }}>
    <path d="M14.0833 7.41667C14.0833 11.0967 11.0967 14.0833 7.41667 14.0833C3.73667 14.0833 1.49 10.3767 1.49 10.3767M1.49 13.71V10.3767H4.50333M0.75 7.41667C0.75 3.73667 3.71 0.75 7.41667 0.75C11.8633 0.75 14.0833 4.45667 14.0833 4.45667M11.1233 4.45667H14.0833V1.12333" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
  </svg>

);
  
export default RefreshCircleIcon20pxSvgV2;
